import { render, staticRenderFns } from "./InternalTransferTab.vue?vue&type=template&id=b7862212"
import script from "./InternalTransferTab.vue?vue&type=script&lang=js"
export * from "./InternalTransferTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports